import React, { Component } from 'react';
import './ListaCalProgAsis.css';

import { getprogcals, clearErrors, deleteProgCal, postCalibracion, editProgCal } from '../../../redux/actions/dataactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Box, CircularProgress, Typography } from '@mui/material';


export class ListaCalProgAsis extends Component {
  constructor() {
    super();
    this.state = {
      horainicio: '',
      horafinal: '',
      fecha: '',
      numcertificado: '',
      errors: {},
      open: false,
      opendelete: false,
      progid: '',
      selectedFile: null,
    };
  }

  componentDidMount() {
    this.props.getprogcals(this.props.equipoId);
  }

  

  render() {
    const { progracals, loadingcal } = this.props.data;

    const sortedProgs = Array.isArray(progracals)
      ? [...progracals].sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
      : [];

    const columns = [
      { field: 'fecha', headerName: 'Fecha', width: 120 },
      { field: 'hora', headerName: 'Hora', width: 100 },
      { field: 'duracion', headerName: 'Duración', width: 120 },
      { field: 'estado', headerName: 'Estado', width: 120 },
      { field: 'lugar', headerName: 'Lugar', width: 200 },
     
    ];

    return (
      <Box className="listamtoprog-container" sx={{ width: '100%' }}>
     
         <Typography sx={{ fontSize: '16px', color: '#03178c', fontWeight: 600, textAlign: 'center', mb: 1 }}>
                                       Calibraciones Programadas
                                     </Typography>

        <Box className="listamtoprog-table" sx={{ mt: 1 }}>
          {loadingcal ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
              <CircularProgress size={50} color="primary" />
            </Box>
          ) : (
            <DataGrid
              rows={sortedProgs}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5, 10, 20]}
              getRowId={(row) => row.progid || row.id}
              components={{
                Toolbar: () => (
                  <Box p={1}>
                    <GridToolbarQuickFilter placeholder="Buscar..." />
                  </Box>
                )
              }}
              sx={{
                height: 500,
                width: '100%',
                mt: 2,
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: 'primary.main',
                  color: 'white'
                }
              }}
            />
          )}
        </Box>
      </Box>
    );
  }
}

ListaCalProgAsis.propTypes = {
  getprogcals: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  deleteProgCal: PropTypes.func.isRequired,
  editProgCal: PropTypes.func.isRequired
};

const mapActionsToProps = { getprogcals, clearErrors, deleteProgCal, editProgCal, postCalibracion };

const mapStateToProps = (state) => ({
  data: state.data,
  UI: state.UI
});

export default connect(mapStateToProps, mapActionsToProps)(ListaCalProgAsis);